export const SEARCH_SUGGESTION_ITEM_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.SearchSuggestionItemElement';
